import { Card, CardContent, Spinner } from '@crm/ui';
import { PlanOffer } from '@/modules/billing/components/plan-offer';
import { useWhatsappUnit } from '../hooks';
import { ChargeStep } from './charge-step';
import { LineSummary } from './line-summary';
import { UnitHeader } from './unit-header';
import { WhatsappSummary } from './whatsapp-summary';

function Bloco({ children }: { children: React.ReactNode }) {
  return (
    <Card variant="flush">
      <CardContent className="py-5">{children}</CardContent>
    </Card>
  );
}

export function UnitDetail({ unitId }: { unitId: string }) {
  const { carregando, unidade, linha } = useWhatsappUnit(unitId);

  if (carregando) {
    return (
      <div className="flex justify-center py-16">
        <Spinner className="h-6 w-6 text-muted-foreground" />
      </div>
    );
  }

  if (!unidade) return <UnitHeader title="Unidade nao encontrada" />;

  return (
    <div className="space-y-4">
      <UnitHeader title={unidade.name} />

      <Bloco>
        <WhatsappSummary unit={unidade} linha={linha} />
      </Bloco>

      {linha && !linha.openCharge ? (
        <Bloco>
          <LineSummary linha={linha} />
        </Bloco>
      ) : null}

      {linha?.openCharge ? (
        <Bloco>
          <ChargeStep linha={linha} onPaid={() => {}} />
        </Bloco>
      ) : null}

      <PlanOffer />
    </div>
  );
}
